import React, { Component } from "react";

import MercyMinistryImg from "../../assets/images/ministries/MercyMinistry.jpg";

class MercyMinistry extends Component {
	render() {
		return (
			<section>
				<header id="page-title">
					<div className="container">
						<h1>Mercy Ministry</h1>
					</div>
				</header>
				<section className="container">
					<img src={MercyMinistryImg} style={{ float: "right" }} alt="" />
					<p>
						As part of living lives committed to Jesus, we are committed to caring for people as he also cared for them,
						not just for their spiritual needs but also for their physical ones. If you would like to find out more
						about how you can get involved in this ministry, or are in need of it yourself, please contact the office or
						email <a href="mailto:mercyministry@kingstoncrc.org.au">mercyministry@kingstoncrc.org.au</a>
					</p>

					<p>
						<strong>
							We are aware that during the COVID-19 pandemic circumstances for people are changing dramatically. If
							either you, or someone you know is unexpectedly in need of assistance contact us via the email above and
							we will try assist you in whatever way we can. Please know that we are praying for you and the members of
							our community at this time.
						</strong>
					</p>
				</section>
			</section>
		);
	}
}

export default MercyMinistry;
